window.addEventListener('turbolinks:load', () => {
  flatpickr(".datepicker", {
    enableTime: true,
    dateFormat: "d/m/Y H:i",
    minDate: "today",
    time_24hr: true,
    defaultDate: $("#automation_default_scheduled_at").val() != '' ? $("#automation_default_scheduled_at").val() : changeTimezone(new Date(), "America/Sao_paulo").getTime(),
    minuteIncrement: 1
  });
  if ($("#automation_default_scheduled_at").val() != '') {
    $("#automation_scheduled_at").val($("#automation_default_scheduled_at").val())
  }
  $('#campaign_messages').on('cocoon:before-insert', function (e, insertedItem, originalEvent) {
    select = $(insertedItem).find('select')[0]
    $(select).on('change', '', function (e) {
      checkSelect(this)
    });
  });
  $('#campaign_messages').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
    if ($('.row_campaign_message_fields').not('[style*="display: none"]').length >= 10) {
      $('.add_campaign_message_fields').hide()
    }
  });
  $('#campaign_messages').on('cocoon:after-remove', function (e, insertedItem, originalEvent) {
    if ($('.row_campaign_message_fields').not('[style*="display: none"]').length < 10) {
      $('.add_campaign_message_fields').show()
    }
  });
  $('.row_campaign_message_fields').on('change', '', function (e) {
    select = $(this).find('select')[0]
    checkSelect(select)
  });
  $('.row_campaign_message_fields').each(function (index, value) {
    select = $(value).find('select')[0]
    checkSelect(select)
  });
  if ($('.row_campaign_message_fields').not('[style*="display: none"]').length < 10) {
    $('.add_campaign_message_fields').show()
  }
  $('#automation_repeat').on('change', '', function (e) {
    check_repeat_time();
  });

  function check_repeat_time() {
    if (parseInt($('#automation_repeat').val()) == 1) {
      $('.repeat_time').show()
    } else {
      $('.repeat_time').hide()
    }
  }
  check_repeat_time();
})

function checkSelect(select) {
  var isPoll = $(select).val() == '16';
  var messageField = $(select).parent().next();
  var pollWrapper = messageField.find('.poll_fields_wrapper');
  var linkPreviewWrapper = messageField.find('.link_preview_wrapper');
  var messageLabel = messageField.find('.message_label');
  var messageTextarea = messageField.find('textarea');

  if (isPoll) {
    pollWrapper.show();
    linkPreviewWrapper.hide();
    messageLabel.text('Pergunta da Enquete');
    messageTextarea.attr("placeholder", 'Digite a pergunta da enquete (ex: Qual o melhor horário para nosso encontro?)');
  } else {
    pollWrapper.hide();
    if ($(select).val() == '1') {
      linkPreviewWrapper.show();
    } else {
      linkPreviewWrapper.hide();
    }
    messageLabel.text('Mensagem');
  }

  if ($(select).val() == '1') {
    $(select).parent().next().next().next().next().show();
  } else if ($(select).val() == '2' || $(select).val() == '3' || $(select).val() == '15' || $(select).val() == '4' || $(select).val() == '5' || $(select).val() == '12') {
    $(select).parent().next().addClass('col-lg-4');
    $(select).parent().next().removeClass('col-lg-7');
    $(select).parent().next().next().show();
    if ($(select).val() == '2' || $(select).val() == '12') {
      $($(select).parent().next().next().find('input')[0]).attr("accept", '.png, .jpg, .jpeg');
    } else if ($(select).val() == '3' || $(select).val() == '15') {
      $($(select).parent().next().next().find('input')[0]).attr("accept", '.mp4, video/mp4');
    } else if ($(select).val() == '4') {
      $($(select).parent().next().next().find('input')[0]).attr("accept", 'audio/*');
    } else if ($(select).val() == '5') {
      $($(select).parent().next().next().find('input')[0]).attr("accept", '.pdf');
    }
  } else {
    $(select).parent().next().removeClass('col-lg-4');
    $(select).parent().next().addClass('col-lg-7');
    $(select).parent().next().next().hide();
  }

  if (isPoll) {
    // Already set above
  } else if ($(select).val() == '6') {
    $($(select).parent().next().find('textarea')[0]).attr("placeholder", 'Informe o título do grupo');
  } else if ($(select).val() == '7') {
    $($(select).parent().next().find('textarea')[0]).attr("placeholder", 'Informe o descrição do grupo');
  } else if ($(select).val() == '8' || $(select).val() == '9' || $(select).val() == '10' || $(select).val() == '11' || $(select).val() == '12') {
    $($(select).parent().next().find('textarea')[0]).attr("placeholder", '');
  } else if ($(select).val() == '13') {
    $($(select).parent().next().find('textarea')[0]).attr("placeholder", 'Digite o título do botão na primeira linha\nDigite o link do botão na segunda linha');
  } else {
    $($(select).parent().next().find('textarea')[0]).attr("placeholder", 'Utilize {n} para pegar o número do grupo, exemplo: Nome do grupo #{n} ...');
  }
}

$(document).on('click', '.add_poll_option', function (e) {
  e.preventDefault();
  var container = $(this).closest('.poll_fields_wrapper').find('.poll_options_container');
  var items = container.find('.poll_option_item');
  if (items.length >= 12) {
    alert('O WhatsApp permite no máximo 12 opções por enquete.');
    return;
  }
  var inputName = $(this).data('input-name');
  var nextIdx = items.length + 1;
  var html = '<div class="input-group input-group-sm mb-2 poll_option_item">' +
             '  <div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-list-ul"></i></span></div>' +
             '  <input type="text" name="' + inputName + '" class="form-control poll_option_input" placeholder="Opção ' + nextIdx + '">' +
             '  <div class="input-group-append">' +
             '    <button type="button" class="btn btn-outline-danger remove_poll_option" title="Remover Opção"><i class="fa fa-times"></i></button>' +
             '  </div>' +
             '</div>';
  container.append(html);
});

$(document).on('click', '.remove_poll_option', function (e) {
  e.preventDefault();
  var container = $(this).closest('.poll_options_container');
  if (container.find('.poll_option_item').length <= 2) {
    alert('Uma enquete precisa de no mínimo 2 opções.');
    return;
  }
  $(this).closest('.poll_option_item').remove();
  container.find('.poll_option_item').each(function (index, el) {
    $(el).find('input').attr('placeholder', 'Opção ' + (index + 1));
  });
});

function changeTimezone(date, ianatz) {
  // suppose the date is 12:00 UTC
  var invdate = new Date(date.toLocaleString('en-US', {
    timeZone: ianatz
  }));
  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  var diff = date.getTime() - invdate.getTime();
  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract
}

window.validateFiles = function (inputFile) {
  var maxExceededMessage = "Tamanho máximo por arquivo (15 MB)";
  var maxFileSize = $(inputFile).data('max-file-size');
  var sizeExceeded = false;
  var extError = false;

  // Extensions listed in the accept attribute or defaults
  var acceptAttr = $(inputFile).attr('accept');
  var allowedExtension = ["jpg", "jpeg", "gif", "png", "mp3", "mp4", "pdf", "mov", "ogg", "csv", "md", "txt", "json", "xls", "xlsx", "doc", "docx"];

  if (acceptAttr && acceptAttr.includes('.')) {
    allowedExtension = acceptAttr.split(',').map(function (ext) {
      return ext.trim().replace('.', '').toLowerCase();
    });
  }

  var extErrorMessage = "Apenas arquivos " + allowedExtension.map(function(ext) { return "." + ext; }).join(", ") + " são permitidos.";

  $.each(inputFile.files, function () {
    if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) { sizeExceeded = true; };
    var extName = this.name.split('.').pop().toLowerCase();
    if ($.inArray(extName, allowedExtension) == -1) { extError = true; };
  });

  if (sizeExceeded) {
    window.alert(maxExceededMessage);
    $(inputFile).val('');
  };

  if (extError) {
    window.alert(extErrorMessage);
    $(inputFile).val('');
  };
}
